import React from 'react';
import axios from 'axios';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { environmentVariables } from '../../../../config/env.config';
import CircularLoader from '../../../Components/CircularLoader/CircularLoader';
import { toast } from 'react-toastify';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

export const LogisticHome = ({colorData}) => {

 const commonString = Yup.string().transform(value => value.replace(/\s+/g, ' ').trim())

 const commonStringWithAddressValidation = Yup.string().transform(value => value.replace(/\s+/g, ' ').trim()).matches(/^[\u0600-\u06FFa-zA-Z0-9\s,.'\-\/]+$/, 'Only letters, numbers, Arabic characters, spaces, commas, periods, hyphens, and slashes are allowed.');


 const validationSchema= Yup.object({
  name: commonString
    .required('Name is required')
    .min(2, 'Name must be at least 2 characters')
    .max(50, 'Name must not exceed 50 characters')
    .matches(/^[\u0600-\u06FFa-zA-Z ]+$/, 'Name can only contain Arabic or English letters and spaces'),

  mobile: Yup.string()
    .transform(value => value.trim())
    .required('Mobile number is required')
    .max(15, 'Mobile number must not exceed 15 characters')
    .matches(/^(\+\d{1,4}-\d{7,12})$/, 'Enter a valid Indian or international mobile number'),

  origin: commonStringWithAddressValidation
    .required('Pickup Address is required')
    .min(3, 'Too short — enter city or pin code')
    .max(100, 'Pickup Address must not exceed 100 characters'),

  destination: commonStringWithAddressValidation
    .required('Drop Address is required')
    .min(3, 'Too short — enter city or pin code')
    .max(100, 'Drop Address must not exceed 100 characters'),

    shipment_weight: Yup.string()
    .required('Weight is required')
    .matches(/^(?!.*\s)(?!^-)[0-9]+(\.[0-9]{1,2})?$/, 'Weight must be a positive number without spaces or negative sign and up to 2 decimal places')
    .test('max-chars', 'Weight must not exceed 8 characters including decimal', value => value?.length <= 8),
  
  pickup_details: commonString
    .min(10, 'Minimum 10 characters required')
    .max(200, 'Pickup details must not exceed 200 characters')
    .matches(/^[\u0600-\u06FFa-zA-Z0-9 ]+$/, 'Only letters, numbers, Arabic characters, and spaces are allowed'),
})

  const formik = useFormik({
    initialValues: {
      business_id: colorData?.id ,
      name: '',
      mobile:'',
      origin: '',
      destination: '',
      shipment_weight: '',
      pickup_details: '',
    }, 
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const cleanedData = validationSchema.cast(values);
        const response = await axios.post(`${environmentVariables?.apiUrl}api/v1/business/create_logistic_enquiry`, cleanedData);
        toast.success('Enquiry submitted successfully!'); 
        resetForm();
      } catch (error) {
        console.error("Submission error:", error);
        toast.error('Something went wrong!');
      }
    }
  });

  return (
  <>
  <style>
  {`
  #temp63 .main-card {
    & .inputField {
        &:hover, &:active, &:focus, &:focus-within, &:target {
            border-color: ${colorData?.dynamicCtaColor}80;
        }
    }
}`}
  </style>
    <div className="sec logisticHome">
        <form onSubmit={formik.handleSubmit}>
      <div className='main-card' 
      // style={{ background:colorData?.dynamicBackgroundColor || '#fff'}}
      >
        <h3 className="sectitle" 
        // style={{color: colorData?.dynamicTextDescriptionColor || '#000'}}
        >Pickup Request</h3>
      
          <div className='inputField'>
            <p>Name*</p>
            <input
              type='text'
              name='name'
              placeholder='Enter your name'
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              onKeyDown={e => {
                const value = e.target.value;
                if (e.key === ' ' && value.length === 0) {
                  e.preventDefault();
                }
              }}
            />
          </div>
          {formik.touched.name && formik.errors.name && (
              <div className="error">{formik.errors.name}</div>
            )}
          <div className='inputField'>
              <p 
              // style={{ color: colorData?.dynamicTextDescriptionColor || '#000' }}
              >Phone Number*</p>
              <PhoneInput
              countryCodeEditable={false}
                international
                country="in" 
                value={formik.values.mobile}
                onChange={(value, country) => {
                  const formattedValue = `+${country.dialCode}-${value.substring(country.dialCode.length)}`;
                  formik.setFieldValue('mobile', formattedValue);
                }}
                onBlur={formik.handleBlur}
                placeholder="Enter contact number"
              />
            </div>
          {formik.touched.mobile && formik.errors.mobile && (
              <div className="error">{formik.errors.mobile}</div>
            )}

          <div className='inputField'>
            <p 
            // style={{color: colorData?.dynamicTextDescriptionColor || '#000'}}
            >Pickup Address*</p>
            <input
              type='text'
              name='origin'
              placeholder='Pickup pin code/Sending from'
              value={formik.values.origin}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              onKeyDown={e => {
                const value = e.target.value;
                if (e.key === ' ' && value.length === 0) {
                  e.preventDefault();
                }
              }}
            />
          </div>
          {formik.touched.origin && formik.errors.origin && (
              <div className="error">{formik.errors.origin}</div>
            )}

          <div className='inputField'>
            <p 
            // style={{color: colorData?.dynamicTextDescriptionColor || '#000'}}
            >Drop Address*</p>
            <input
              type='text'
              name='destination'
              placeholder='Deliver pin code/Sending to'
              value={formik.values.destination}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              onKeyDown={e => {
                const value = e.target.value;
                if (e.key === ' ' && value.length === 0) {
                  e.preventDefault();
                }
              }}
            />
           
          </div>
          {formik.touched.destination && formik.errors.destination && (
              <div className="error">{formik.errors.destination}</div>
            )}


          <div className='inputField'>
            <p 
            // style={{color: colorData?.dynamicTextDescriptionColor || '#000'}}
            >Shipment Weight* (Approx.)</p>
            <input
              type='text'
              name='shipment_weight'
              placeholder='Enter weight (In Kg)'
              value={formik.values.shipment_weight}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              onKeyDown={e => {
                const value = e.target.value;
                if (e.key === ' ' && value.length === 0) {
                  e.preventDefault();
                }
              }}
            />
            
          </div>
          {formik.touched.shipment_weight && formik.errors.shipment_weight && (
              <div className="error">{formik.errors.shipment_weight}</div>
            )}

          <div className='inputField'>
            <p 
            // style={{color: colorData?.dynamicTextDescriptionColor || '#000'}}
            >Pickup Detail (Optional)</p>
            <textarea
              name='pickup_details'
              rows={3}
              placeholder='Specific information'
              value={formik.values.pickup_details}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              onKeyDown={e => {
                const value = e.target.value;
                if (e.key === ' ' && value.length === 0) {
                  e.preventDefault();
                }
              }}
            />
            
          </div>
          {formik.touched.pickup_details && formik.errors.pickup_details && (
              <div className="error">{formik.errors.pickup_details}</div>
            )}

          <button className='enquiryButton' type='submit' style={{color : colorData?.dynamicCtaTextColor || '#fff', background: colorData?.dynamicCtaColor}}>{formik.isSubmitting ? <CircularLoader size={25}/> : 'Enquiry' }</button>
       
      </div>
      </form>
    </div>
    </>
  );
};
        